import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSessionStorage } from "usehooks-ts";
import { selectUser, userActions } from "../../app/reducers/UserSlice";
import Navbar from "../book/components/Navbar";
import { INITIAL_DETAILS } from "./DetailsWizard";

const BookFlowLayout = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const user = useSelector(selectUser);
  const [draft, setDraft] = useSessionStorage("bookCreationDraft", null);

  useEffect(() => {
    dispatch(userActions.principal());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const incoming = location.state?.selectedMemories;
  const incomingBook = location.state?.bookDetails;

  const buildInitialBookDetails = () => {
    const base = {
      ...INITIAL_DETAILS,
      firstName: incomingBook?.firstName ?? "",
      lastName: incomingBook?.lastName ?? "",
    };
    if (!incomingBook) return base;
    const overrides = Object.keys(INITIAL_DETAILS).reduce((acc, key) => {
      if (incomingBook[key] !== undefined && incomingBook[key] !== null) {
        acc[key] = incomingBook[key];
      }
      return acc;
    }, {});
    return { ...base, ...overrides };
  };

  useEffect(() => {
    if (incoming) {
      setDraft((prev) => {
        return {
          selectedMemories: incoming,
          selectedMemoriesDetails:
            location.state?.selectedMemoriesDetails ?? [],
          bookDetails: prev?.bookDetails ?? buildInitialBookDetails(),
          bookId: incomingBook?.id ?? prev?.bookId ?? null,
        };
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [incoming]);

  const effectiveDraft = incoming
    ? {
        selectedMemories: incoming,
        selectedMemoriesDetails: location.state?.selectedMemoriesDetails ?? [],
        bookDetails: draft?.bookDetails ?? buildInitialBookDetails(),
        bookId: incomingBook?.id ?? draft?.bookId ?? null,
      }
    : draft;

  if (!effectiveDraft) {
    return <Navigate to="/memories" replace />;
  }

  const updateBookDetails = (updaterOrValue) => {
    setDraft((prev) => {
      const base = prev ?? effectiveDraft;
      return {
        ...base,
        bookDetails:
          typeof updaterOrValue === "function"
            ? updaterOrValue(base.bookDetails)
            : updaterOrValue,
      };
    });
  };

  const clearDraft = () => setDraft(null);

  return (
    <>
      <Navbar />
      <Outlet
        context={{
          selectedMemories: effectiveDraft.selectedMemories,
          selectedMemoriesDetails: effectiveDraft.selectedMemoriesDetails,
          bookDetails: effectiveDraft.bookDetails,
          bookId: effectiveDraft.bookId ?? null,
          updateBookDetails,
          clearDraft,
        }}
      />
    </>
  );
};

export default BookFlowLayout;
